const PreRender = (props) => {

    const { Component } = props

    return Component && Component.hasOwnProperty('WrappedComponent') ? <Component key={Math.random()} /> : <></>
}

export default PreRender;